// extracted by mini-css-extract-plugin
export default {"container":"FaucetMenu_container__Kxiyh","item":"FaucetMenu_item__vGQt9","form":"FaucetMenu_form__3fDdG"};